import { render, staticRenderFns } from "./RankTop10.vue?vue&type=template&id=f6f5440c&scoped=true"
import script from "./RankTop10.vue?vue&type=script&lang=js"
export * from "./RankTop10.vue?vue&type=script&lang=js"
import style0 from "./RankTop10.vue?vue&type=style&index=0&id=f6f5440c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f6f5440c",
  null
  
)

export default component.exports